import React from "react";
import Loader from "react-loader-spinner";

function MyLoader() {
  return (
    <div className="row column small-1 small-center">
      <Loader type="ThreeDots" color="#CECECE" height={100} width={100} />
    </div>
  );
}

export default MyLoader;
